import React, { useEffect, useState } from "react";
import GuideSection from "../../components/guide/GuideSection";
import { juridiqueGuide } from "../../components/guide/guideContent";
import { formatPrice } from "../../utils/formatPrice";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../../redux/actions/CartActions";
import pricing from "../../assets/data/pricing.json";
import { Col, Image, Row } from "react-bootstrap";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import serviceCode from "../../assets/data/serviceCode.json";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateGrhRequest,
  updateJuridiqueRequest,
  updateManagementRequest,
  updateSalesRequest,
} from "../../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";

function EditPlatformJuridique() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const {
    businessCreationRequest,
    domiciliationRequest,
    managementRequest,
    juridiqueRequest,
    adminRequest,
    grhRequest,
    salesRequest,
  } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleButtonClick = async () => {
    setSubmitting(true);

    let updatedServices = [...servicesList];
    // Vérifie si un élément avec le même code existe déjà
    const existingIndex = updatedServices.findIndex(
      (service) => service.code === serviceCode.platformJuridique,
    );

    const newService = {
      code: serviceCode.platformJuridique,
      billing: selectedPlan === "annuel" ? "yearly" : "monthly",
    };

    if (existingIndex !== -1) {
      updatedServices[existingIndex] = newService;
    } else {
      updatedServices.push(newService);
    }

    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "domiciliation") {
      await dispatch(
        updateDomiciliationRequest(
          user.token,
          domiciliationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "management") {
      await dispatch(
        updateManagementRequest(
          user.token,
          managementRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "admin") {
      await dispatch(
        updateAdminRequest(
          user.token,
          adminRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "juridique") {
      await dispatch(
        updateJuridiqueRequest(
          user.token,
          juridiqueRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "grh") {
      await dispatch(
        updateGrhRequest(
          user.token,
          grhRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "sales") {
      await dispatch(
        updateSalesRequest(
          user.token,
          salesRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    }
  };

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          platformJuridique: {
            periodicity: selectedPlan,
            amount:
              selectedPlan === "annuel"
                ? pricing.platformJuridique.annuel
                : pricing.platformJuridique.mensuel,
          },
        }),
      );

      await dispatch(
        addToServiceList({
          code: serviceCode.platformJuridique,
          billing: selectedPlan === "annuel" ? "yearly" : "monthly",
        }),
      );
      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        <div
          className="container my-4 text-center"
          style={{ maxWidth: "800px" }}
        >
          <h4 className="text-2xl font-semibold">
            Gérez vos{" "}
            <span style={{ color: "#FF5500" }}>dossiers juridiques</span> avec
            <span style={{ color: "#FF5500" }}> PlatformJuridique</span>
          </h4>
        </div>

        <div className="container mt-4">
          <Row>
            <Col md={4} className="mb-3">
              <Image
                src="/images/juridique/professional_litigation.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Suivis contentieux professionnel
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <Image
                src="/images/juridique/business_contracts.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Contrats d’affaires
              </div>
            </Col>
            <Col md={4} className="mb-3">
              <Image
                src="/images/juridique/legal_secretary.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Secrétariat juridique
              </div>
            </Col>
          </Row>
        </div>

        <div className="container text-center">
          <h5 className="mb-3">Choisissez votre abonnement</h5>
          <div className="d-flex justify-content-center gap-4">
            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="mensuel"
                checked={selectedPlan === "mensuel"}
                onChange={() => setSelectedPlan("mensuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformJuridique.mensuel)} / mois
                (abonnement mensuel)
              </span>
            </label>

            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="annuel"
                checked={selectedPlan === "annuel"}
                onChange={() => setSelectedPlan("annuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformJuridique.annuel)} / mois
                (abonnement annuel)
              </span>
            </label>
          </div>
        </div>

        <div className="container text-center mt-4">
          <button
            className="btn"
            style={{
              backgroundColor: "#051259",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
            onClick={handleButtonClick}
          >
            Obtenir ce service
            <FaArrowRight style={{ marginLeft: "8px" }} />
          </button>
        </div>

        <div className="container text-center mt-3">
          <span
            onClick={handleSkipClick}
            style={{ color: "#3392FF", cursor: "pointer" }}
          >
            Retour
          </span>
        </div>

        <GuideSection {...juridiqueGuide} />
      </>
    </div>
  );
}

export default EditPlatformJuridique;
